<hip-modal [routeToGoOnBackdropClick]="'/auth'">
  <lib-privacy-policy [mustSelectOption]="true"></lib-privacy-policy>
</hip-modal>
